module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"illuminations\"-in-garden-grove-california-a93b7659890f68d995079681c9c4d314.png";